import * as React from 'react';

const DraggerSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={69} height={5} fill="none" {...props}>
        <rect y={0.25} width={69} height={4} rx={2} fill="#DBDAE3" />
    </svg>
);

DraggerSvg.displayName = 'DraggerSvg';
export default DraggerSvg;
